import { Button, Link as DSLink, Heading, List } from "@icg360/design-system";

import { PublicHeader } from "components/public-header";
import { PageFooter } from "components/shared/page-footer";
import { StatusMessageAlert } from "components/status-message/alert";

import styles from "./login-page.module.scss";

const LoginPage = () => {
  return (
    <>
      <PublicHeader className={styles.nav} />
      <StatusMessageAlert />
      <div className={styles.fullRow}>
        <div className={styles.pageContainer}>
          <div className={styles.contentColumn}>
            <section className={styles.content}>
              <Heading size="lg" className={styles.loginHead}>
                Welcome to SageSure
              </Heading>
              <Heading size="md" className={styles.loginSubhead}>
                Log in to securely access and manage your account.
              </Heading>
              <div className={styles.list}>
                <List>
                  <li>View billing information and manage payments</li>
                  <li>Submit or check the status of a claim</li>
                  <li>View and download policy documents</li>
                </List>
              </div>
              <a
                className={styles.buttonLink}
                href="/auth/login"
                data-testid="signInLink"
              >
                <Button>Log in</Button>
              </a>
              <p>
                New here?{" "}
                <DSLink href="/auth/signup" data-testid="signUpLink">
                  Activate your account
                </DSLink>
              </p>
            </section>
          </div>
        </div>
        <div className={styles.cover}></div>
      </div>
      <PageFooter unauthenticated />
    </>
  );
};

export default LoginPage;
